import { DefaultPrimaryButton, DefaultSecondaryButton } from '@frontend/components/common';
import { CommonMessage } from '@frontend/lang';

import { KioskNavigationFooter } from '../../../components/kiosk-navigation-footer.component';
import useWizardNavigationFooter from './wizard-navigation-footer.controller';

const ID = 'wizard-navigation-footer';
export interface WizardNavigationFooterProps {
    onSubmit?: () => void;
    submitDisabled?: boolean;
    submitLabel?: React.ReactNode;
    onBack?: () => void;
}

const WizardNavigationFooter = (props: WizardNavigationFooterProps) => {
    const viewProps = useWizardNavigationFooter(props);

    if (!viewProps.onBack && !props.onSubmit) {
        return null;
    }

    return (
        <KioskNavigationFooter
            leftButton={
                viewProps.onBack ? (
                    <DefaultSecondaryButton
                        text={CommonMessage.BUTTONS.GO_BACK}
                        onClick={viewProps.onBack}
                    />
                ) : undefined
            }
            rightButton={
                props.onSubmit ? (
                    <DefaultPrimaryButton
                        text={props.submitLabel || (viewProps.finalStep ? CommonMessage.BUTTONS.EXIT : CommonMessage.BUTTONS.CONTINUE)}
                        onClick={() => {
                            if (props.submitDisabled) return;
                            props.onSubmit && props.onSubmit();
                        }}
                        disabled={props.submitDisabled}
                    />
                ) : undefined
            }
        />
    );
};

export default WizardNavigationFooter;
